import { faAt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonLink } from "../molecules/Button";

// const users = [
//   {
//     href: "https://zenn.dev/ttani",
//     name: "ttani",
//   },
//   {
//     href: "https://zenn.dev/tocca_wachi",
//     name: "tocca_wachi",
//   },
//   {
//     href: "https://zenn.dev/toccaduong",
//     name: "toccaduong",
//   },
//   {
//     href: "https://zenn.dev/mmorichika",
//     name: "mmorichika",
//   },
//   {
//     href: "https://zenn.dev/hhnd",
//     name: "hhnd",
//   },
//   {
//     href: "https://zenn.dev/maki_k",
//     name: "maki_k",
//   },
//   {
//     href: "https://zenn.dev/gentz",
//     name: "gentz",
//   },
//   {
//     href: "https://zenn.dev/knagano",
//     name: "knagano",
//   },
//   {
//     href: "https://zenn.dev/tns_00",
//     name: "tns_00",
//   },
//   {
//     href: "https://zenn.dev/ymoutai",
//     name: "ymoutai",
//   },
// ];

export const TopTechBlog = (props) => {
  let blogs = props.blogs;
  return (
    <>
      <div className="relative mx-auto box-border flex max-w-7xl flex-col justify-between gap-2 px-6 text-txt-base sm:px-8 md:px-12 lg:flex-row lg:items-start xl:px-0">
        <h6 className="font-bold text-pri fluid-text-[16px,22px] ">
          ToccaSystems Tech Blog
        </h6>
        <div className="md:max-w-[616px]">
          <h3 className="font-bold leading-comfort text-txt-base fluid-text-[14px,18px] ">
            トッカシステムズのメンバーが「エンジニアのための情報共有コミュニティZenn」にて技術情報を発信しています
          </h3>
        </div>
      </div>
      <div className="mx-auto mt-6 box-border grid max-w-7xl grid-cols-2 gap-2 px-6 sm:grid-cols-3 sm:px-8 md:mt-8  md:grid-cols-5 md:gap-5 md:px-12 lg:mt-10 xl:px-0">
        {blogs.map((user) => (
          <div className="col-span-1 md:col-span-1" key={user.index}>
            <ButtonLink
              href={"https://zenn.dev/" + user.account}
              target="_blank"
              variant="outline"
              color="qua"
              className="h-[48px] w-full rounded-md fluid-text-[13px,16px] md:h-[64px]"
            >
              <FontAwesomeIcon
                icon={faAt}
                className="mr-2 text-sns-zenn  group-hover:text-hov"
              />
              {user.account}
            </ButtonLink>
          </div>
        ))}
      </div>
    </>
  );
};
